import { Container } from 'react-bootstrap';

function AboutUs() {
  return (
    <div>
      <Container fluid className="limited-width bg ogs-pri-text text-center py-5 mb-5">
        <h1 className="ogs-sec-text">About Us</h1>
      </Container>

      <Container fluid className="limited-width bg ogs-pri-text text-center py-5 mb-5">
        <p>
          Welcome to <b className="ogs-high-text">Omni Group Services</b> – or OG Services for short. We are a multi-service technology and business solutions company that helps organisations solve real problems with practical, modern tools.
        </p>

        <p>
          Our journey started with a single developer armed with roughly 10 years of battle-tested experience in the wild world of software.  
          Since then, we’ve grown into a powerhouse with skills spanning everything from fitness apps that make you sweat 💪 (in a good way),  
          to insurance systems that keep you covered 🛡️, to global import-export platforms that move mountains (and containers) 🌍🚢,  
          and even business transactional banking that keeps the money flowing 💸.  
          In short, we do it all — from sleek websites to complex enterprise solutions — and we do it with style. ✨
        </p>

        <p>
          We thrive on challenges. Let’s be honest, coding the same thing over and over is about as exciting as watching paint dry 🎨😴.  
          But every business has its own quirky rules and puzzles 🧩, and that’s what keeps our brains buzzing 🧠 and our coffee cups full ☕.  
          Because if everything was easy all the time, who’d be jazzed to roll out of bed and hit the keyboard each morning? ⏰💻
        </p>

        <p>
          But wait, there’s more! We’re not just code monkeys 🐒 chained to our desks. We foster a collaborative, learning-driven environment where no  
          industry is off-limits. Need us to dive into something new? Bring it on! We’re not afraid to get our hands dirty 🛠️ — whether it’s debugging  
          tricky software or assembling your office furniture (okay, maybe not the furniture 🪑, but we’re close).
        </p>

        <p>
          At OGS, we want to be challenged, pushed, and tested. So if you’ve got a tough problem, or even just need someone to help you pick out a  
          desk chair, we’re your go-to crew. 🤝
        </p>
      </Container>
    </div>
  );
}

export default AboutUs;